export default "__VITE_ASSET__e276ea39__"